import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import * as React from 'react';

function LinearProgressWithLabel(props: ILinearProgressWithLabelProps) {
	return (
		<Box display='flex' alignItems='center'>
			<Box width='100%' mr={1}>
				<LinearProgress variant='determinate' {...props} />
			</Box>
			<Box minWidth={35}>
				<Typography variant='body2' color='textSecondary'>
					{`${Math.round(props.value)}%`}
				</Typography>
			</Box>
		</Box>
	);
}
export interface ILinearProgressWithLabelProps {
	/**
	 * The value of the progress indicator for the determinate and buffer variants.
	 * Value between 0 and 100.
	 */
	value: number;
}

export default LinearProgressWithLabel;



// WEBPACK FOOTER //
// ./src/components/shared/linear-progress.component.tsx